var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.6032 0L8.85332 11.0312L0.551102 20H2.4196L9.68817 12.1477L15.561 20H21.9195L13.2052 8.34833L20.9329 0H19.0644L12.3704 7.23185L6.96176 0H0.6032ZM3.35096 1.37634H6.2721L19.1714 18.6235H16.2502L3.35096 1.37634Z","fill":"white"}));
}

Twitter.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
